const QuizProgress = ({ step, total, progress, isContactStep }) => (
  <div data-testid="detector-quiz-progress" className="mb-8">
    <div className="flex items-center justify-between mb-3">
      <span className="font-mono-file text-[10px] tracking-[0.25em] text-[#71717A] uppercase">
        {isContactStep ? "Final Step" : `Question ${step + 1} of ${total - 1}`}
      </span>
      <span className="font-mono-file text-[10px] tracking-[0.25em] text-[#FFD166]">
        {progress}%
      </span>
    </div>
    <div className="h-[3px] w-full bg-white/10">
      <div
        className="h-full bg-[#FFD166] transition-[width] duration-500 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  </div>
);

export default QuizProgress;
